<template>
    <div class="widget-inner">
        <div v-if="entries.length" class="padding-5">
            <div v-for="scope of entries">
                <div class="padding-5">
                    <div class="font-size-16 padding-bottom-2">
                        <strong>{{scope.title}}</strong>
                    </div>

                    <div v-for="type of scope.types">
                        <router-link :to="type.link" class="padding-bottom-2">
                            <strong>{{type.type}}</strong>
                        </router-link>

                        <div v-for="ticket of type.tickets" :class="['flex-vertical-middle gap-5 padding-4', {'bottom-border': ticket !== type.tickets[type.tickets.length - 1]}]">
                              <span v-tooltip :aria-label="ticket.system.title" class="colour-badge medium margin-right-3">
                                      <span v-if="ticket.system.color"
                                          :style="{backgroundColor: '#' + ticket.system.color}" class="colour-badge-preview"/>
                                    <span v-else :style="{border: 'solid 1px'}" class="colour-badge-preview"/>
                              </span>

                            <div>#{{scope.alias}}{{ticket.scope_ticket_id}}</div>

                            <div>-</div>

                            <router-link v-tooltip :to="'/issue-tracker/ticket/view/id/' + ticket.id"
                                :title="ticket.title" class="text-overflow">
                                [{{ticket.module}}]
                            </router-link>

                            <div class="flex-grow"></div>

                            <div :style="ticket.priority.color.length ? `color: ${ticket.priority.color};` : ''">{{ticket.priority.title}}</div>
                        </div>
                    </div>
                </div>

                <router-link v-if="content.hasMore" :to="buildLink(scope.id)" class="flex margin-right-10 margin-bottom-3">
                    <div class="text-overflow flex--item-right text-underline">
                        <span>Alle ansehen</span>
                        <i class="material-icons small-icon" aria-hidden="true" role="img">open_in_new</i>
                    </div>
                </router-link>
            </div>
        </div>
        <div v-else class="widget-empty-message">
            <div :style="isPersonalDashboardWidget ? {color} : {}">
                {{widget.emptyMessage}}
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component} from 'vue-facing-decorator';
    import {WidgetDefault} from './WidgetDefault.vue';

    @Component({
        name: 'WidgetTicket',
    })
    export class WidgetTicket extends WidgetDefault
    {
        get entries(): IIssueTrackerPersonalDashboardWidgetScopes[]
        {
            return this.content.entries as IIssueTrackerPersonalDashboardWidgetScopes[];
        }

        buildLink(scopeId: number): string
        {
            return `/issue-tracker/ticket/scope-id/${scopeId}/tab/overview#search={"condition:strict":[0],"assignees:strict":[${this.currentUser.id}],"ovr":1}`;
        }
    }

    export default WidgetTicket;
</script>